<template>
  <!-- 数据值展示列，只显示数据值不能编辑 -->
  <div class="data-column" :class="showBorder? 'border': ''">
    <div class="data-label"><slot name="label">{{label}}</slot></div>
    <div class="value"><slot/></div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  props: {
    label: {default: ''},
    showBorder: {default: true},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "DC",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.data-column{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  &.border{
    border-bottom: 1px solid var(--yq-background-color);
  }
  &:first-child{
    margin-top: 10px;
  }
  &:last-child{
    border-bottom: none;
  }
  .value{
    flex: 1;
    text-align: right;
  }
  :deep(input) {
    border: none;
    border-bottom: 1px solid var(--yq-background-color);
    text-align: right;
    height: 40px;
    line-height: 40px;
    width: 100%;
    outline: none;
    box-sizing: border-box;
  }
  .data-label{
    color: var(--yq-font-color-desc);
  }
}
</style>